export const widgetReferral = {
    title: "Parrainage",
    code: "Votre code :",
    godchild: "Parrainé|Parrainé|Parrainés",
    months: "Mois gagnés",
    'more-informations': {
        label: "plus d'informations…",
        title: "Plus d'informations sur le parrainage"
    }
}
